import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import {
  BadgeTitle,
  BadgeValue,
  CardBody,
  InfoBadge,
  NoDataContainer,
} from '../../styles';
import Typography from '@mui/material/Typography';
function DataDisplay({
  modeView,
  customerData,
}: {
  modeView: string;
  customerData: CustomerDataType;
}) {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Stack gap="16px" sx={{ width: '100%' }}>
      {customerData ? (
        <CardBody modeView={modeView === 'grid'}>
          {/** USER PPP */}
          <InfoBadge modeView={modeView}>
            <BadgeTitle>
              {t('equipment.customer.customerData.userPPP')}
            </BadgeTitle>
            <BadgeValue>{customerData.userPPP ?? '-'}</BadgeValue>
          </InfoBadge>

          {/** PASSWORD PPP */}
          <InfoBadge modeView={modeView}>
            <BadgeTitle>
              {t('equipment.customer.customerData.passwordPPP')}
            </BadgeTitle>
            <BadgeValue>{customerData.passwordPPP ?? 'N/A'}</BadgeValue>
          </InfoBadge>

          {/** CUSTOMER CODE */}
          <InfoBadge modeView={modeView}>
            <BadgeTitle>
              {t('equipment.customer.customerData.customerCode')}
            </BadgeTitle>
            <BadgeValue>{customerData.customerCode ?? 'N/A'}</BadgeValue>
          </InfoBadge>

          {/** NAME */}
          <InfoBadge modeView={modeView} wide={true}>
            <BadgeTitle>
              {t('equipment.customer.customerData.customerName')}
            </BadgeTitle>
            <BadgeValue>{customerData.customerName ?? 'N/A'}</BadgeValue>
          </InfoBadge>

          {/** SOCIAL IDENTIFIER */}
          <InfoBadge modeView={modeView}>
            <BadgeTitle>
              {t('equipment.customer.customerData.socialId')}
            </BadgeTitle>
            <BadgeValue>{customerData.socialId ?? 'N/A'}</BadgeValue>
          </InfoBadge>

          {/** ADDRESS */}
          <InfoBadge modeView={modeView} fullWidth={true}>
            <BadgeTitle>
              {t('equipment.customer.customerData.address')}
            </BadgeTitle>
            <BadgeValue fullWidth>{customerData.address ?? 'N/A'}</BadgeValue>
          </InfoBadge>
        </CardBody>
      ) : (
        <NoDataContainer>
          <Typography variant="h6" color={theme.palette.grey['01']}>
            {t('equipment.customer.customerData.noData')}
          </Typography>
        </NoDataContainer>
      )}
    </Stack>
  );
}

export default DataDisplay;
